import React from "react";
import SafeguardingViolationsDashboard from "./SafeguardingDashboard";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./components/Login";

const ProtectedApp = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  return isAuthenticated ? <SafeguardingViolationsDashboard /> : <Login />;
};

function App() {
  return (
    <AuthProvider>
      <ProtectedApp />
    </AuthProvider>
  );
}

export default App;
